export default "__VITE_ASSET__C5TYC_4y__"